import { ProductCommission } from 'services/api/common-types/types-commissions';

import { get } from '../base';

export function getMany(productsIds: string[]): Promise<ProductCommission[]> {
  const idsQueryString = productsIds.join(',');
  return get(`v3/commissions/products?ids=${idsQueryString}`).json();
}
